export const drawManufacturerLabel = (manufacturer) => {
    return manufacturer.name;
};
